import { Component, OnInit } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { APIService } from 'src/app/api.service';


@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {
  isWeb: boolean = true;

  constructor(private router: Router, private Commservice : CommonService, private apiService : APIService) { }

  ngOnInit(): void {

    this.isWeb = this.apiService.apiCheckWeb();

  }

reportArr: any = [{
    title: '',
    titleColorCls: 'tealText',
    itemHeaderColorCls: 'gradTealBkgd',
    reportItems: [
      {
        title: 'Consumption Analysis',
        desc: 'Ideal vs Actual consumption of materials for past production jobs, to check over-use or misuse',
        link: '',
        index: 1
        
      },
      {
        title: 'Rejection Cause Analysis',
        desc: 'Identification of causes of rejection and contribution to output loss',
        link: '',
        index: 2
      },
      {
        title: 'Production History',
        desc: 'Month-wise history of launched production jobs',
        link: '',
        index: 3
      },
      {
        title: 'Product-wise Mfg Analysis',
        desc: 'Product-wise analysis of production jobs, completion punctuality, and rejections',
        link: '',
        index: 4
      },
      {
        title: 'Production Output',
        desc: 'Day-wise production statistics, including work done and rejection',
        link: '',
        index: 5
      }
      // {
      //   title: 'Material Availability',
      //   desc: 'Verification of availability of materials for production of selected products',
      //   link: '',
      //   index: 6
      // }
    ]
  }
  ]

InventoryReportsRedirect(index: number) {
 
  let target: string = "_blank";
  if(this.isWeb == false){
      target = "_self";
  }

  if (index == 1) {
    this.router.navigate(['/RptPrdConsumptionAnalysis']);
  }

  if (index == 2) {
    this.router.navigate(['/RptPrdRejectionAnalysis']);
  }

  if (index == 3) {
    this.router.navigate(['/RptPrdJobHistory']);
  }

  if (index == 4) {
    this.router.navigate(['/RptPrdProdWiseManufacturing']);
  }

  if (index == 5) {
    this.router.navigate(['/RptPrdProdnOutput']);
  }

  // if (index == 6) {
  //   this.router.navigate(['/RptInvMtlAvailability']);
  // }
}
 
backBtn() {
  this.router.navigate(['/ProductionList']);
}
}
